import { createSlice } from '@reduxjs/toolkit'

import { confirmEmail } from './thunks'

interface AgencyEmailState {
  emailConfirmation: {
    status: boolean | null
    error: string | null
    confirmationSent: boolean
  }
}

export const initialState: AgencyEmailState = {
  emailConfirmation: {
    status: null,
    error: null,
    confirmationSent: false,
  },
}

const getConfirmationError = (payload: unknown): string | null => {
  const typedErrors = (
    payload as { $errors?: Array<{ message?: string; original_message?: string }> } | undefined
  )?.$errors
  const legacyErrors = (payload as { errors?: string[] } | undefined)?.errors
  const nestedLegacyErrors = (payload as { error?: { errors?: string[] } } | undefined)?.error
    ?.errors
  const payloadMessage =
    (payload as { message?: unknown; error?: unknown } | undefined)?.message ??
    (payload as { message?: unknown; error?: unknown } | undefined)?.error

  return (
    typedErrors?.[0]?.message ??
    typedErrors?.[0]?.original_message ??
    legacyErrors?.[0] ??
    nestedLegacyErrors?.[0] ??
    (typeof payloadMessage === 'string' ? payloadMessage : null) ??
    null
  )
}

const emailSlice = createSlice({
  name: 'agency/email',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(confirmEmail.pending, (state) => {
        state.emailConfirmation = { confirmationSent: true, status: null, error: null }
      })
      .addCase(confirmEmail.fulfilled, (state) => {
        state.emailConfirmation = {
          ...state.emailConfirmation,
          status: true,
          confirmationSent: false,
        }
      })
      .addCase(confirmEmail.rejected, (state, action) => {
        state.emailConfirmation = {
          ...state.emailConfirmation,
          status: false,
          error:
            getConfirmationError(action.payload) ??
            (action.error.message === 'Rejected' ? null : action.error.message) ??
            null,
          confirmationSent: false,
        }
      })
  },
})

export default emailSlice.reducer
